import ProfilePersonalInformationForm from './ProfilePersonalInformationForm'

export default ProfilePersonalInformationForm
